module.exports = __webpack_public_path__ + "assets/img/18_297_big.4baa7b58.jpg";